import { getFileType } from './fileTypeUtils';
import { ReuploadPolicy } from '../types/reuploadPolicy';

const getNormalizedExtension = (fileName = '') => {
  return getFileType('', fileName).toLowerCase();
};

export const isOverwriteReuploadExtension = (fileName = '', policy?: ReuploadPolicy | null) => {
  if (!policy) {
    return false;
  }

  const extension = getNormalizedExtension(fileName);
  return policy.allowedExtensions.includes(extension);
};

export const canOverwriteReupload = (fileName = '', storageType?: string, policy?: ReuploadPolicy | null) => {
  if (!policy) {
    return false;
  }

  if (!policy.temporaryAllowed && storageType === 'TEMPORARY') {
    return false;
  }

  return isOverwriteReuploadExtension(fileName, policy);
};

export const hasMatchingOverwriteReuploadExtension = (
  selectedFileName = '',
  targetFileName = '',
  policy?: ReuploadPolicy | null
) => {
  if (!policy) {
    return false;
  }

  const selectedExtension = getNormalizedExtension(selectedFileName);
  const targetExtension = getNormalizedExtension(targetFileName);

  if (!selectedExtension || !targetExtension) {
    return false;
  }

  if (!isOverwriteReuploadExtension(targetFileName, policy)) {
    return false;
  }

  return !policy.sameExtensionRequired || selectedExtension === targetExtension;
};
